// شاشة القفل بالبصمة/الوجه لتطبيق الموبايل، وسؤال التفعيل بعد أوّل دخول (قرار المالك 03/10/2026: «يفتح التطبيق مرة وبعد
// كده يربطه ببصمة الوجه أو بصمة الموبايل، وبعد كده التطبيق يفضل شغّال عادي زي الواتساب»). منطقها في lib/appLock.ts.
import { useCallback, useEffect, useState } from 'react';
import { Modal } from '../components/ui.tsx';
import { awayLongEnough, bioAvailable, bioPref, markHidden, setBioPref, verifyBio } from '../lib/appLock.ts';

export function AppLock({ name, onPasswordLogin }: { name: string; onPasswordLogin: () => void }) {
  // null = لسه بيتسأل الموبايل: والقفل يظهر من اللحظة الأولى لا بعد السؤال — فلا تُرى الشاشات لحظةً قبله
  const [available, setAvailable] = useState<boolean | null>(null);
  // يبدأ مقفولًا لو البصمة مفعّلة وغاب عنه صاحبه ساعة أو أكثر (أو أوّل فتح) — والرجوع قبلها يفتح مباشرة
  const [locked, setLocked] = useState(() => bioPref() === 'on' && awayLongEnough());
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    void bioAvailable().then(ok => {
      if (!alive) return;
      setAvailable(ok);
      if (!ok) setLocked(false);                  // موبايلٌ بلا بصمة ولا قفل شاشة: لا قفل يُحبس فيه أحد
      else if (bioPref() === null) setAsk(true);  // أوّل دخول: يُسأل مرّة واحدة
    });
    return () => { alive = false; };
  }, []);

  // الخلفية: وقت الخروج يُحفظ، والرجوع بعد ساعة أو أكثر يقفل (RELOCK_SECONDS)
  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === 'hidden') markHidden();
      else if (bioPref() === 'on' && available !== false && awayLongEnough()) setLocked(true);
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [available]);

  const unlock = useCallback(async () => {
    setBusy(true); setFailed(false);
    const ok = await verifyBio();
    setBusy(false);
    if (ok) setLocked(false); else setFailed(true);
  }, []);

  // القفل يطلب البصمة وحده فور ظهوره — لا يحتاج ضغطة
  useEffect(() => { if (locked && available === true) void unlock(); }, [locked, available, unlock]);

  async function enable() {
    setBusy(true);
    const ok = await verifyBio();
    setBusy(false);
    setBioPref(ok ? 'on' : 'off');
    setAsk(false);
  }

  if (locked && available !== false) {
    return (
      <div role="dialog" aria-modal="true" aria-label="التطبيق مقفول"
        className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-5 bg-brand-900 px-6 text-center text-white"
        style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
        <img src="/assets/icontravel-mark.png" alt="" aria-hidden="true" className="h-24 w-24 rounded-full shadow-lg" />
        <div>
          <p className="text-lg font-bold">أهلًا {name}</p>
          <p className="mt-1 text-sm text-white/75">افتح التطبيق ببصمتك أو بوجهك</p>
        </div>
        <button type="button" disabled={busy || available !== true} onClick={() => void unlock()}
          className="rounded-2xl bg-white px-8 py-3 text-base font-bold text-brand-700 shadow disabled:opacity-60">
          {busy ? '…' : '🔓 افتح'}
        </button>
        {failed && <p className="text-sm text-amber-200">ما اتعرفتش — جرّب تاني.</p>}
        <button type="button" onClick={onPasswordLogin} className="text-sm text-white/70 underline">
          الدخول بكلمة السر بدلها
        </button>
      </div>
    );
  }

  if (ask) {
    return (
      <Modal title="الدخول بالبصمة أو الوجه" size="sm" onClose={() => { setBioPref('off'); setAsk(false); }}>
        <p className="text-sm leading-7 text-ink-800">
          تحب تفتح التطبيق بعد كده <b>ببصمتك أو بوجهك</b> بدل كلمة السر؟ هتفضل داخل على طول زي الواتساب، والإشعارات توصلك
          حتى والموبايل مقفول.
        </p>
        <div className="mt-4 flex gap-2">
          <button type="button" className="btn-primary px-5 py-2" disabled={busy} onClick={() => void enable()}>
            {busy ? '…' : 'فعّلها'}
          </button>
          <button type="button" className="btn-ghost px-5 py-2" onClick={() => { setBioPref('off'); setAsk(false); }}>مش دلوقتي</button>
        </div>
      </Modal>
    );
  }
  return null;
}
